module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('c-loader', {
    staticClass: "c-project-list"
  }) : _c('div', {
    staticClass: "view-wrapper project"
  }, [_c('div', {
    staticClass: "project__hero",
    style: ('background-image:url(' + _vm.project.featuredImageUrl + ')')
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.project.title) ? _c('h1', {
    staticClass: "project__title",
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "project__content"
  }, [_c('div', {
    staticClass: "project__description",
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  }), _vm._v(" "), _c('c-project-facts', {
    attrs: {
      "facts": _vm.project.facts
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project__flex-content"
  }, [_c('c-flex-content', {
    attrs: {
      "content": _vm.project.flex_content
    }
  })], 1), _vm._v(" "), (_vm.project.relatedProjects) ? _c('section', {
    staticClass: "project__otherprojects"
  }, [_c('h3', [_vm._v(_vm._s(_vm.localizedRelatedProjectsButtonText))]), _vm._v(" "), _c('c-project-list', {
    attrs: {
      "ids": _vm.project.relatedProjects,
      "padded": "true"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55c2451e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Project.vue
// module id = 267
// module chunks = 0